<template>
    <div class="content">
        <div class="tab-container">
            <p class="title">驗證結果</p>
            <b-table class="upload_table w-100" :items="items" :fields="fields" :sort-by.sync="sortBy" label-sort-asc="" label-sort-desc="" label-sort-clear="" :sort-desc.sync="sortDesc" sticky-header hover responsive="sm" @row-clicked="rowOnClick">
                <template #cell(result)="data">
                    <template v-if="data.value">
                        <div class="text-nowrap">
                            <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" class="mr-1"></b-icon><span class="text-success">驗證成功</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="text-nowrap">
                            <b-icon icon="x-circle-fill" variant="danger" aria-hidden="true" class="mr-1"></b-icon><span class="text-alert">驗證失敗</span>
                        </div>
                    </template>
                </template>
            </b-table>
        </div>
        <div class="footer">
            <button class="btn-secondary-blue mx-3" @click="resetVerify()">回選擇驗證證據</button>
            <button @click="clickReport()" class="btn-primary-sm mx-3">匯出結果</button>
        </div>
        <b-modal id="modal-hash" size="xl" title="" header-bg-variant="secondary" centered>
            <div class="d-block text-left">
                <b-row>
                    <b-col cols="12">
                        <template v-if="modalItems.result">
                            <p class="text-break mb-2" v-if="modalItems.fileName">檔案名稱：{{modalItems.fileName}}</p>
                            <p class="text-break mb-2" v-else-if="modalItems.hash">檔案雜湊值：{{modalItems.hash}}</p>
                        </template>
                        <template v-else>
                            <p class="text-break mb-2">檔案雜湊值：{{modalItems.hash}}</p>
                        </template>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" lg="6">
                        <div class="text-nowrap text-primary">
                            <p class="mb-2">驗證結果：
                                <template v-if="modalItems.result">
                                    <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" class="mr-1"></b-icon><span class="text-success">驗證成功</span>
                                </template>
                                <template v-else>
                                    <b-icon icon="x-circle-fill" variant="danger" aria-hidden="true" class="mr-1"></b-icon><span class="text-alert">驗證失敗</span>
                                </template>
                            </p>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <p class="mb-2">驗證時間：{{modalItems.verifyTime}}</p>
                    </b-col>
                </b-row>
                <div class="hash-table-container" v-if="modalItems.result">
                    <div class="hash-table text-break mx-3">
                        <b-row class="bg-primary">
                            <b-col class="px-2">區塊鏈資訊</b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div>存證時間</div>
                                    <div v-if="modalItems.txMap">{{modalItems.txMap.datetime}}</div>
                                    <div v-else>&nbsp;</div>
                                </div>
                            </b-col>
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div>Transation ID</div>
                                    <div v-if="modalItems.txMap">{{modalItems.txMap.txid}}</div>
                                    <div v-else>&nbsp;</div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div>Chanel名稱</div>
                                    <div>mojchannel-test</div>
                                </div>
                            </b-col>
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div>Chaincode名稱</div>
                                    <div>example</div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="bg-primary">
                            <b-col class="px-2">存證資訊</b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div class="px-2 py-1">機關單位</div>
                                    <div class="px-2 py-1" v-if="modalItems.user.user_company">{{modalItems.user.user_company}}</div>
                                    <div class="px-2 py-1" v-else>&nbsp;</div>
                                </div>
                            </b-col>
                            <b-col cols="12" lg="6" class="px-0">
                                <div class="d-flex flex-column">
                                    <div class="px-2 py-1">存證人員</div>
                                    <div class="px-2 py-1" v-if="modalItems.user.user_name">{{modalItems.user.user_name}}</div>
                                    <div class="px-2 py-1" v-else>&nbsp;</div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="w-100 text-center">
                    <button class="btn-primary-sm mx-3" @click="$bvModal.hide('modal-hash')">
                        關閉
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment'

export default {
    name: "UploadResultPage",
    props: {
        items: Array
    },
    methods: {
        // routerPush(url) {
        //     this.$router.push(url);
        // },
        // handleDelete(index) {
        //     this.items.splice(index, 1);
        // },
        rowOnClick(record) {
            if (record.txMap && record.txMap.timestamp) {
                record.txMap.datetime = moment.unix(Math.floor(record.txMap.timestamp / 1000)).format('YYYY/MM/DD HH:mm:ss');
            }
            this.modalItems = record;
            this.$bvModal.show('modal-hash');
        },
        clickReport() {
            let routerData = this.$router.resolve({ path: '/verifyReport' });
            window.open(routerData.href, '_blank');
        },
        resetVerify(){
            location.reload();
        }
    },
    data() {
        return {
            sortBy: "index",
            sortDesc: false,
            fields: [{
                    key: "index",
                    sortable: true,
                    label: "項目",
                    thClass: "text-white",
                    class: "border-td"
                },
                {
                    key: "fileName",
                    sortable: true,
                    label: "檔案名稱",
                    thClass: "text-white",
                    class: "border-td"
                },
                {
                    key: "hash",
                    sortable: false,
                    label: "雜湊值",
                    thClass: "text-white",
                    class: "border-td"
                },
                {
                    key: "result",
                    sortable: false,
                    label: "",
                    thClass: "text-white",
                    class: "border-td text-center td-fixed",
                },
            ],
            modalItems: {},
        };
    }
};
</script>
